import React, { useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import TiptapEditor from '@/components/TiptapEditor';
import { IS_PROD } from '@/utils/environment';
import Hotjar from '@hotjar/browser';
import WorkspaceSaveButton from '@/components/buttons/WorkspaceSaveButton';
import VersionHistoryButton from '@/components/buttons/VersionHistoryButton';
import { useWorkspaceContext } from '@/context/WorkspaceContext';
import UnsavedChangesActions from '@/components/UnsavedChangesActions';

export const WorkspaceTab = () => {
	const { objectType, draftHtml, savedHtml, isUnsaved, isBusy, handleChange } =
		useWorkspaceContext();
	const editorWrapperRef = useRef(null);

	const workspaceViewEvent = {
		client: 'client_workspace_clicked',
		deal: 'deal_workspace_clicked',
		relationshipCompany: 'relationship_company_workspace_clicked',
	}[objectType];

	// Marks tab has been viewed in hotjar...
	const hasTracked = useRef(false);
	useEffect(() => {
		if (IS_PROD && !hasTracked.current && workspaceViewEvent) {
			try {
				Hotjar.event(workspaceViewEvent);
				hasTracked.current = true;
			} catch (error) {
				console.error('Failed to track workspace view:', error);
			}
		}
	}, [workspaceViewEvent]);

	return (
		<Box
			ref={editorWrapperRef}
			sx={{
				'& .tiptap-toolbar, & .tiptap-editor': {
					borderTopLeftRadius: '0',
					borderTopRightRadius: '0',
				},
				'& .tiptap-toolbar': {
					position: 'sticky',
					borderBottom: '1px solid',
					borderColor: 'divider',
					top: 0,
					zIndex: 10,
				},
				'& .tiptap-editor': {
					'& table': {
						width: '100%',
					},
				},
			}}
		>
			<TiptapEditor
				value={draftHtml ?? savedHtml}
				disabled={isBusy}
				onChange={handleChange}
				placeholder='Start typing...'
				minHeight='80vh' //full length of editor
				config={{
					toolbar: {
						user: {
							show: false,
							showSignature: false,
						},
						brokerage: { show: false },
						image: { show: true },
						table: {
							show: true,
							resizable: true,
							defaultBorderColor: '#d3d3d3',
							defaultBorders: {
								top: true,
								bottom: true,
								left: true,
								right: true,
							},
						},
						deal: { show: false },
						client: { show: false },
						riskInfo: { show: false },
						align: { show: true },
					},
				}}
			/>
			<UnsavedChangesActions isUnsaved={isUnsaved}>
				<VersionHistoryButton />
				<WorkspaceSaveButton />
			</UnsavedChangesActions>
		</Box>
	);
};

export default WorkspaceTab;
WorkspaceTab.displayName = 'WorkspaceTab';
